import { ReactNode } from 'react'
import { Popover } from 'antd'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import EventCard from 'screens/Rostering/components/EventCard'

type AllocatedEventsPopoverProps = {
  children: ReactNode
  events?: any[]
}

const AllocatedEventsPopover = ({
  children,
  events,
}: AllocatedEventsPopoverProps) => {
  const { t } = useTranslation()

  if (!events) return null

  return (
    <Popover
      placement="bottomRight"
      showArrow
      trigger="hover"
      arrow={{ pointAtCenter: true }}
      content={
        <AllocatedPopover>
          <Text weight="medium" level={2}>
            {t('ALLOCATED_TO')}
          </Text>
          <EventsContainer>
            {events.map((event) => (
              <EventCard key={event.id} event={event} />
            ))}
          </EventsContainer>
        </AllocatedPopover>
      }
    >
      {children}
    </Popover>
  )
}

const AllocatedPopover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 4px;
`
const EventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export default AllocatedEventsPopover
